<div
  class="tag"
  [class]="{
    'green': value,
    'purple': !value,
  }"
>
  <span>{{ value ? "Yes" : "No" }}</span>
</div>
